<div class="container">
  <div class="messenger-box">
    <div>
      <label for="facebook-id" class="input-label">Nhập Zalo OAID tại đây:</label>
      <input id="facebook-id" class="input-field" placeholder="Nhập Zalo OAID" nz-input
        [(ngModel)]="data.staticdata.zaloShareAttributes.data_oaid" />
        <button mat-raised-button color="primary" class="btn-update mt-2" (click)="updateObject({staticdata: data.staticdata})">Cập nhật</button>
    </div>
    <p class="mt-4">
      Hướng dẫn cách lấy OA ID của Zalo doanh nghiệp tại
      <span (click)="showModal()" class="guide">đây</span>
    </p>
  </div>
  <nz-modal [(nzVisible)]="isVisible"
    [nzStyle]="{ maxHeight: '80vh', top: '32px', overflowY : 'scroll', 'paddingBottom': '0' }" 
    [nzWidth]="'70%'"
    (nzOnCancel)="handleCancel()"
    (nzOnOk)="handleOk()">
    <ng-container *nzModalContent>
      <img style="width: auto; height: auto" src="/assets/root/images/system/imgs/cach_lay_oaid.jpg" />
    </ng-container>
  </nz-modal>
</div>